module.exports = __webpack_public_path__ + "static/media/loading.a21746f5.gif";